<template>
  <el-button size="mini" @click="pushView">
    View
  </el-button>
</template>

<script>
export default {
  props: {
    recipe: Object,
  },
  methods: {
    pushView() {
      window.open(`${ process.env.VUE_APP_APP_HOST }/recipes/${ this.recipe.slug }~${ this.recipe.id }`)
    }
  }
}
</script>
